import * as React from "react";
import useReactRouter from "use-react-router";
import { Link } from "react-router-dom";
import cx from "classnames";
// constants
import { STATUS_OF_DELETED_USER } from "@vingle/wtf-sdk/constants/default";
import RoundImage from "common/components/roundImage";
import SmallFollowButton from "common/components/smallFollowButton";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { useTrackTicket } from "@vingle/wtf-sdk/helpers/trackTicket";
import translateURLToAppURL from "@vingle/wtf-sdk/helpers/translateURLToAppURL";
// styles
const styles = require("./cardItem.scss");

interface IProps {
  user: Vingle.User.IListUser;
  isOwn: boolean;
  onFollowClick: (user: Vingle.User.IListUser) => void;
  referralUrl?: string;
  className?: string;
}

function UserItem(props: IProps) {
  const { user, isOwn, onFollowClick, referralUrl, className } = props;
  const isFollowing = Boolean(user.relation && user.relation.following);
  const isDeletedUser = user.status === STATUS_OF_DELETED_USER;
  const handleUserFollow = React.useCallback(() => {
    onFollowClick(user);
  }, [onFollowClick, user]);
  const { location } = useReactRouter();
  const { handleRead } = useTrackTicket({
    contentId: user.id,
    contentType: "user",
    referralUrl: referralUrl || translateURLToAppURL(location.pathname),
  });
  let interests = "";
  if (user.top_interests) {
    interests = user.top_interests.map(({ name }) => name).join(" ･ ");
  }
  return (
    <div className={cx(styles.bodyWrapper, className)}>
      <Link
        to={new VingleURL.UserShow({ username: user.username }).toString()}
        className={styles.contentWrapper}
        onClick={handleRead}
      >
        <RoundImage
          imageSrc={user.profile_image_urls}
          width={42}
          height={42}
          wrapperStyles={{ marginBottom: 8 }}
        />
        <div className={styles.username} title={user.username}>
          {user.username}
        </div>
        {interests ? (
          <div className={styles.interests} title={interests}>
            {interests}
          </div>
        ) : null}
        {user.bio && <span className={styles.bio}>{user.bio}</span>}
      </Link>
      {isOwn || isDeletedUser ? null : (
        <SmallFollowButton
          isFollowing={isFollowing}
          onFollow={handleUserFollow}
          onUnFollow={handleUserFollow}
        />
      )}
    </div>
  );
}

export default UserItem;
